import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import messagesService from "api/messagesService";
import { useEffect, useMemo, useState } from "react";
import { IMetric } from "dto/IMetric";
import moment from "moment";
import { randomString } from "utils/randomString";
import Spinner from "components/Spinner";

const MetricDatesModal: FC<Props> = ({ pack }) => {
  const { data: metricData } = messagesService.useGetMetric(pack.Id, pack.Kind);
  const metricD: IMetric = useMemo(() => metricData?.data ?? [], [metricData]);

  const [metric, setMetric] = useState<IMetric | null>(null);

  useEffect(() => {
    setMetric(metricD);
  }, [metricD]);
  if (!metric) {
    return (
      <div className={styles.modal}>
        <div className={styles.wrapper}>
          <div className={styles.body}></div>
          <Spinner></Spinner>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.modal}>
      <div className={styles.wrapper}>
        <div className={styles.body}>
          {metricD?.History && metricD.History.length > 0 && (
            <div className={styles.history}>
              <div className={styles.list}>
                {metricD.History.map((h) => (
                  <div
                    className={styles.box}
                    key={`history_${h.Id ?? randomString()}`}
                  >
                    <div className={styles.boxWrapper}>
                      <div className={styles.line}></div>

                      <div className={styles.dot}></div>

                      <div className={styles.boxContent}>
                        <div className={styles.r1}>
                          <div className={styles.desc}>{h.Description}</div>
                        </div>
                        <div className={styles.r2}>
                          {moment(h.Date).format("yyyy.MM.DD HH:mm")}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricDatesModal;
